import { useState } from "react"

import styles from "../styles/company.module.css"
import getImgUrl from "../helper/getImgUrl";

const COMPANY_DATA = {
    main_photo: "/img/snapphoto-1758578007242-770406984.jpg",
    main_title: "Rooted in craftsmanship",
    commitment: "At The Wetland Shop, we believe every home deserves furniture that tells a story. We source our hardwoods responsibly from local forests and craft each piece by hand to your exact specifications. Our commitment is simple — build things that last, and build them beautifully.",
};

const SKILLS = [
    {
        id: 1,
        skill: "Custom Design",
        skill_intro: "We work directly with you from first sketch to final finish. Every dimension, wood species, and detail is tailored to fit your space and vision perfectly.",
        skill_photo: "/img/snapphoto-1758578007242-770406984.jpg",
    },
    {
        id: 2,
        skill: "Sustainable Sourcing",
        skill_intro: "All our hardwoods are responsibly sourced from local and regional forests. We prioritise reclaimed and live-edge slabs wherever possible to minimise waste.",
        skill_photo: "/img/mainphoto-1758578007231-210425894.jpg",
    },
    {
        id: 3,
        skill: "Handcrafted Finish",
        skill_intro: "Each piece is hand-sanded and finished using food-safe oils and hard-wax finishes that protect the wood while letting its natural grain and character shine through.",
        skill_photo: "/img/snapphoto-1758578007242-770406984-1760375098799-744424057.jpg",
    },
];

const Company = () => {
    const [activeSkillId, setActiveSkillId] = useState(SKILLS[0].id);

    const activeSkill = SKILLS.find(skill => skill.id === activeSkillId);

    return (
        <div className={styles.main_container}>
            <div className={styles.whoweare}>
                <div className={styles.whoimg}>
                   <img src={getImgUrl(COMPANY_DATA.main_photo)} alt=""/>
                </div>
                <div className={styles.intro}>
                    <div className={styles.introContent}>
                        <div className={styles.introTitle}>
                            <h1>{COMPANY_DATA.main_title}</h1>
                        </div>
                        <div className={styles.introDesc}>
                            <div>
                                <p>OUR COMMITMENT</p>
                            </div>
                            <div className={styles.paragraph}>
                                <p>{COMPANY_DATA.commitment}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.whyChooseUs}>
                <h1>WHY CHOOSE THE WETLAND SHOP</h1>
            </div>
            <div className={styles.skills}>
                <div className={styles.category}>
                    <ul>
                        {SKILLS.map((skill) => (
                            <li
                                key={skill.id}
                                className={activeSkillId === skill.id ? styles.active : ''}
                                onClick={() => setActiveSkillId(skill.id)}
                            >
                                <p>{skill.skill}</p>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className={styles.title}>
                    <div>
                        <h1>{activeSkill?.skill}</h1>
                    </div>
                </div>
                <div className={styles.descPhoto}>
                    <div className={styles.desc}>
                        <p>{activeSkill?.skill_intro}</p>
                    </div>
                    <img src={getImgUrl(activeSkill?.skill_photo)} alt=""/>
                </div>
            </div>
        </div>
    )
}

export default Company
